export default "__VITE_ASSET__mMevrEE5__"